export default [
  {
    id: 'fa001',
    nameKey: 'algorithm.fa001.name',
    bannerList: [
      {
        titleKey: 'algorithm.fa001.banner.title',
        descKey: 'algorithm.fa001.banner.desc',
        btnText: '',
        image: require('@/assets/img/Algorithm/banner/banner-01.webp'),
        link: '/about',
        bottomTextsKey: 'home.banner.aiEngine.tags'
      }
    ],
    featureList: [
      {
        titleKey: 'algorithm.fa001.features.outOfBox.title',
        descKey: 'algorithm.fa001.features.outOfBox.desc',
        image: require('@/assets/img/Algorithm/解决方案-煤矿反三违-开箱即用算法库.png'),
      },
      {
        titleKey: 'algorithm.fa001.features.knowledgeLink.title',
        descKey: 'algorithm.fa001.features.knowledgeLink.desc',
        image: require('@/assets/img/Algorithm/解决方案-煤矿反三违-知识库联动预警.png'),
      },
      {
        titleKey: 'algorithm.fa001.features.evidenceTrace.title',
        descKey: 'algorithm.fa001.features.evidenceTrace.desc',
        image: require('@/assets/img/Algorithm/解决方案-煤矿反三违-视频全证据链溯源.png'),
      },
      {
        titleKey: 'algorithm.fa001.features.quickDeploy.title',
        descKey: 'algorithm.fa001.features.quickDeploy.desc',
        image: require('@/assets/img/Algorithm/解决方案-煤矿反三违-软硬件一体快速部署.png'),
      }
    ],
    featureImage: require('@/assets/img/Algorithm/反三违-架构.png'),
    featureSectionList: [
      {
        icon: require('@/assets/img/Algorithm/icon01.webp'),
        titleKey: 'algorithm.fa001.advantages.authority.title',
        descKey: 'algorithm.fa001.advantages.authority.desc'
      },
      {
        icon: require('@/assets/img/Algorithm/icon02.webp'),
        titleKey: 'algorithm.fa001.advantages.knowledgeAssist.title',
        descKey: 'algorithm.fa001.advantages.knowledgeAssist.desc'
      },
      {
        icon: require('@/assets/img/Algorithm/icon03.webp'),
        titleKey: 'algorithm.fa001.advantages.zeroLeak.title',
        descKey: 'algorithm.fa001.advantages.zeroLeak.desc'
      }
    ],
    CustomerCaseList: [
      {
        titleKey: 'home.cases.antiViolationUpgrade.title',
        descKey: 'home.cases.antiViolationUpgrade.desc',
        effectKey: 'home.cases.antiViolationUpgrade.effect',
        evaluationKey: 'home.cases.antiViolationUpgrade.evaluation',
        image: require("@/assets/img/Algorithm/case/解决方案-反三违-case.png")
      }
    ]
  },
  {
    id: 'fa002',
    nameKey: 'algorithm.fa002.name',
    bannerList: [
      {
        titleKey: 'algorithm.fa002.banner.title',
        descKey: 'algorithm.fa002.banner.desc',
        btnText: '',
        image: require('@/assets/img/Algorithm/banner/banner-矿山全场景AI视频识别解决方案.webp'),
        link: '/about',
        bottomTextsKey: 'home.banner.aiEngine.tags'
      }
    ],
    featureList: [
      {
        titleKey: 'algorithm.fa002.features.faceMonitor.title',
        descKey: 'algorithm.fa002.features.faceMonitor.desc',
        image: require('@/assets/img/Algorithm/解决方案-矿山全场景AI视频识别解决方案-综采面智能监控.png'),
      },
      {
        titleKey: 'algorithm.fa002.features.transportProtect.title',
        descKey: 'algorithm.fa002.features.transportProtect.desc',
        image: require('@/assets/img/Algorithm/解决方案-矿山全场景AI视频识别解决方案- 主运输系统防护.png'),
      },
      {
        titleKey: 'algorithm.fa002.features.unmannedRoom.title',
        descKey: 'algorithm.fa002.features.unmannedRoom.desc',
        image: require('@/assets/img/Algorithm/解决方案-矿山全场景AI视频识别解决方案-固定硐室无人值守.png'),
      },
      {
        titleKey: 'algorithm.fa002.features.multiTerminal.title',
        descKey: 'algorithm.fa002.features.multiTerminal.desc',
        image: require('@/assets/img/Algorithm/解决方案-矿山全场景AI视频识别解决方案-全场景多端联动.png'),
      }
    ],
    featureImage: require('@/assets/img/Algorithm/矿山全场景.png'),
    featureSectionList: [
      {
        icon: require('@/assets/img/Algorithm/icon01.webp'),
        titleKey: 'algorithm.fa002.advantages.fullCoverage.title',
        descKey: 'algorithm.fa002.advantages.fullCoverage.desc'
      },
      {
        icon: require('@/assets/img/Algorithm/icon02.webp'),
        titleKey: 'algorithm.fa002.advantages.aiWarning.title',
        descKey: 'algorithm.fa002.advantages.aiWarning.desc'
      },
      {
        icon: require('@/assets/img/Algorithm/icon03.webp'),
        titleKey: 'algorithm.fa002.advantages.closedLoop.title',
        descKey: 'algorithm.fa002.advantages.closedLoop.desc'
      }
    ],
    CustomerCaseList: [
      {
        titleKey: 'home.cases.fullScene.title',
        descKey: 'home.cases.fullScene.desc',
        effectKey: 'home.cases.fullScene.effect',
        evaluationKey: 'home.cases.fullScene.evaluation',
        image: require("@/assets/img/Algorithm/case/矿山全场景AI视频识别-case.png")
      }
    ]
  },
  {
    id: 'fa003',
    nameKey: 'algorithm.fa003.name',
    bannerList: [
      {
        titleKey: 'algorithm.fa003.banner.title',
        descKey: 'algorithm.fa003.banner.desc',
        btnText: '',
        image: require('@/assets/img/Algorithm/banner/banner-化工行业智能监管解决方案.webp'),
        link: '/about',
        bottomTextsKey: 'home.banner.aiEngine.tags'
      }
    ],
    featureList: [
      {
        titleKey: 'algorithm.fa003.features.wearDetect.title',
        descKey: 'algorithm.fa003.features.wearDetect.desc',
        image: require('@/assets/img/Algorithm/解决方案-化工行业智能监管解决方案-危险区规范穿戴检测.png'),
      },
      {
        titleKey: 'algorithm.fa003.features.fireWarning.title',
        descKey: 'algorithm.fa003.features.fireWarning.desc',
        image: require('@/assets/img/Algorithm/解决方案-化工行业智能监管解决方案-火灾烟雾毫秒预警.png'),
      },
      {
        titleKey: 'algorithm.fa003.features.loadingDetect.title',
        descKey: 'algorithm.fa003.features.loadingDetect.desc',
        image: require('@/assets/img/Algorithm/解决方案-化工行业智能监管解决方案-装卸作业合规监管.png'),
      },
      {
        titleKey: 'algorithm.fa003.features.intrusionDetect.title',
        descKey: 'algorithm.fa003.features.intrusionDetect.desc',
        image: require('@/assets/img/Algorithm/解决方案-化工行业智能监管解决方案-周界入侵与违规停留.png'),
      }
    ],
    featureImage: require('@/assets/img/Algorithm/img.png'),
    featureSectionList: [
      {
        icon: require('@/assets/img/Algorithm/icon01.webp'),
        titleKey: 'algorithm.fa003.advantages.proactive.title',
        descKey: 'algorithm.fa003.advantages.proactive.desc'
      },
      {
        icon: require('@/assets/img/Algorithm/icon02.webp'),
        titleKey: 'algorithm.fa003.advantages.fullMonitor.title',
        descKey: 'algorithm.fa003.advantages.fullMonitor.desc'
      },
      {
        icon: require('@/assets/img/Algorithm/icon03.webp'),
        titleKey: 'algorithm.fa003.advantages.linked.title',
        descKey: 'algorithm.fa003.advantages.linked.desc'
      }
    ],
    CustomerCaseList: [
      {
        titleKey: 'home.cases.chemicalPark.title',
        descKey: 'home.cases.chemicalPark.desc',
        effectKey: 'home.cases.chemicalPark.effect',
        evaluationKey: 'home.cases.chemicalPark.evaluation',
        image: require("@/assets/img/Algorithm/case/解决方案-化工解决方案-case.png")
      }
    ]
  },
]